// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, [2076], () => (__webpack_require__("./public/templates/modules/oem_assemblies/oem_assemblies.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
